import React, { useState, useEffect } from 'react';
import './OneToOneReview.css';
import './createadmin.css';
import sortIcon from './images/sort.png';
import msortIcon from './images/msort.png';

const CreateAdmin = () => {
  const [userData, setUserData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [roleUpdates, setRoleUpdates] = useState({});
  const [hlabcUpdates, setHlabcUpdates] = useState({});
  const [universityUpdates, setUniversityUpdates] = useState({});
  const [sortConfig, setSortConfig] = useState({ key: 'Name', direction: 'ascending' });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_SERVER_IP + '/api/admin/user', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      const data = await response.json();
      setUserData(data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleSearch = async () => {
    if (searchQuery === '') {
      fetchData();
    } else {
      try {
        const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/api/admin/user?searchQuery=${searchQuery}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        const data = await response.json();
        setUserData(data);
      } catch (error) {
        console.error('Error searching:', error);
      }
    }
  };

  const handleChange = (e) => setSearchQuery(e.target.value);

  const formatDate = (date) => {
    const parsedDate = new Date(date);
    return `${parsedDate.getDate()}-${parsedDate.toLocaleString('default', { month: 'short' })}-${parsedDate.getFullYear()}`;
  };

  const sortData = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }

    const sorted = [...userData].sort((a, b) => {
      const valueA = (a[key] || '').toString().toLowerCase();
      const valueB = (b[key] || '').toString().toLowerCase();
      if (valueA < valueB) return direction === 'ascending' ? -1 : 1;
      if (valueA > valueB) return direction === 'ascending' ? 1 : -1;
      return 0;
    });

    setSortConfig({ key, direction });
    setUserData(sorted);
  };

  const handleRoleChange = (index, value) => setRoleUpdates({ ...roleUpdates, [index]: value });
  const handleHlabcChange = (index, value) => setHlabcUpdates({ ...hlabcUpdates, [index]: value });
  const handleUniversityChange = (index, value) => setUniversityUpdates({ ...universityUpdates, [index]: value });

  const handleUpdate = async (index, email) => {
    const newRole = roleUpdates[index] || userData[index].role;
    const newHlabc = hlabcUpdates[index] || userData[index].hlabc;
    const newUniversity = universityUpdates[index] || userData[index].universityName;

    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/api/admin/user/${email}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({ role: newRole, hlabc: newHlabc, universityName: newUniversity }),
      });

      if (response.ok) {
        alert('User updated successfully!');
        fetchData();
      } else {
        alert('Failed to update user');
      }
    } catch (error) {
      console.error('Update error:', error);
    }
  };

  return (
    <div className="contain">
      <main className="main-content">
        <div className="table-containerAdd">
           <h2 className='name'>View Users</h2>
          <div className="search-containerAdd">
            <input
              type="text"
              placeholder="Search User"
              value={searchQuery}
              onChange={handleChange}
              onKeyUp={handleSearch}
            />
          </div>

          {/* Desktop Table */}
          <div className="desktop-table">
            <table className="table-heading">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th onClick={() => sortData('Name')}>Name <img src={sortIcon} alt="Sort" className='sort' /></th>
                  <th onClick={() => sortData('company')}>Company Name <img src={sortIcon} alt="Sort" /></th>
                  <th onClick={() => sortData('occupation')}>Category <img src={sortIcon} alt="Sort" /></th>
                  <th onClick={() => sortData('number')}>Contact Number <img src={sortIcon} alt="Sort" /></th>
                  <th onClick={() => sortData('email')}>E-Mail <img src={sortIcon} alt="Sort" /></th>
                  <th>DOB</th>
                  <th>Collage Name</th>
                  <th>Year</th>
                  <th>Role</th>
                  <th>HLABC</th>
                  <th>University</th>
                  <th>Update</th>
                </tr>
              </thead>
              <tbody>
                {userData.length > 0 ? userData.map((entry, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{entry.firstName} {entry.lastName}</td>
                    <td>{entry.company}</td>
                    <td>{entry.occupation}</td>
                    <td>{entry.number}</td>
                    <td>{entry.email}</td>
                    <td>{entry.date ? formatDate(entry.date) : 'No DOB'}</td>
                    <td>{entry.collageName || 'N/A'}</td>
                    <td>{entry.year || 'N/A'}</td>
                    <td>
                      <select value={roleUpdates[index] || entry.role} onChange={(e) => handleRoleChange(index, e.target.value)}>
                        <option value="member">Member</option>
                        <option value="admin">Admin</option>
                      </select>
                    </td>
                    <td>
                      <select value={hlabcUpdates[index] || entry.hlabc} onChange={(e) => handleHlabcChange(index, e.target.value)}>
                        <option value="Member">Member</option>
                        <option value="spouse">Spouse</option>
                      </select>
                    </td>
                    <td>
                      <select value={universityUpdates[index] || entry.universityName} onChange={(e) => handleUniversityChange(index, e.target.value)}>
                        <option value="Gujarat University">Gujarat University</option>
                        <option value="Ahmedabad University">Ahmedabad University</option>
                      </select>
                    </td>
                    <td >
                      <button onClick={() => handleUpdate(index, entry.email)}className='update'>Update</button>
                    </td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan="13">No Data Available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Mobile Table */}
          <div className="mobile-scroll-table-add">
            <div className="mobile-scroll-wrapper">
              <table>
                {/* <thead> */}
                <tbody>
                  <tr>
                    <th className="sticky-col">S.No</th>
                    {userData.map((_, i) => <td key={`sno-${i}`}>{i + 1}</td>)}
                  </tr>
                {/* </thead> */}
          
                  <tr>
                    <th className="sticky-col" onClick={() => sortData('date')}>Name <img src={msortIcon} alt="Sort" className="sort-iconm" /></th>
                    {userData.map((u, i) => <td key={`name-${i}`}>{u.firstName} {u.lastName}</td>)}
                  </tr>
                  <tr>
                    <th className="sticky-col" onClick={() => sortData('date')}>Company Name <img src={msortIcon} alt="Sort" className="sort-iconm" /></th>
                    {userData.map((u, i) => <td key={`comp-${i}`}>{u.company}</td>)}
                  </tr>
                  <tr>
                    <th className="sticky-col" onClick={() => sortData('date')}>Category <img src={msortIcon} alt="Sort" className="sort-iconm" /></th>
                    {userData.map((u, i) => <td key={`cat-${i}`}>{u.occupation}</td>)}
                  </tr>
                  <tr>
                    <th className="sticky-col" onClick={() => sortData('date')}>Number <img src={msortIcon} alt="Sort" className="sort-iconm" /></th>
                    {userData.map((u, i) => <td key={`num-${i}`}>{u.number}</td>)}
                  </tr>
                  <tr>
                    <th className="sticky-col" onClick={() => sortData('date')}>Email <img src={msortIcon} alt="Sort" className="sort-iconm" /></th>
                    {userData.map((u, i) => <td key={`email-${i}`}>{u.email}</td>)}
                  </tr>
                  <tr>
                    <th className="sticky-col" onClick={() => sortData('date')}>DOB <img src={msortIcon} alt="Sort" className="sort-iconm" /></th>
                    {userData.map((u, i) => <td key={`dob-${i}`}>{u.date ? formatDate(u.date) : 'No DOB'}</td>)}
                  </tr>
                  <tr>
                    <th className="sticky-col" onClick={() => sortData('date')}>Collage Name <img src={msortIcon} alt="Sort" className="sort-iconm" /></th>
                    {userData.map((u, i) => <td key={`coll-${i}`}>{u.collageName || 'N/A'}</td>)}
                  </tr>
                  <tr>
                    <th className="sticky-col" onClick={() => sortData('date')}>Year <img src={msortIcon} alt="Sort" className="sort-iconm" /></th>
                    {userData.map((u, i) => <td key={`year-${i}`}>{u.year || 'N/A'}</td>)}
                  </tr>
                  <tr>
                    <th className="sticky-col" onClick={() => sortData('date')}>Role <img src={msortIcon} alt="Sort" className="sort-iconm" /></th>
                    {userData.map((u, i) => (
                      <td key={`role-${i}`}>
                        <select value={roleUpdates[i] || u.role} onChange={(e) => handleRoleChange(i, e.target.value)} className="sticky-col">
                          <option value="member">Member</option> 
                          <option value="admin">Admin</option>
                        </select>
                      </td>
                    ))}
                  </tr>
                  <tr>
                    <th className="sticky-col" onClick={() => sortData('date')}>HLABC <img src={msortIcon} alt="Sort" className="sort-iconm" /></th>
                    {userData.map((u, i) => (
                      <td key={`hlabc-${i}`}>
                        <select value={hlabcUpdates[i] || u.hlabc} onChange={(e) => handleHlabcChange(i, e.target.value)} className="sticky-col">
                          <option value="Member">Member</option>
                          <option value="spouse">Spouse</option>
                        </select>
                      </td>
                    ))}
                  </tr>
                  <tr>
                    <th className="sticky-col" onClick={() => sortData('date')}>University <img src={msortIcon} alt="Sort" className="sort-iconm" /></th>
                    {userData.map((u, i) => (
                      <td key={`uni-${i}`}>
                        <select value={universityUpdates[i] || u.universityName} onChange={(e) => handleUniversityChange(i, e.target.value)} className="sticky-col">
                          <option value="Gujarat University">Gujarat University</option>
                          <option value="Ahmedabad University">Ahmedabad University</option>
                        </select>
                      </td>
                    ))}
                  </tr>
                  <tr>
                    <th>Update</th>
                    {userData.map((u, i) => (
                      <td key={`btn-${i}`}>
                        <button onClick={() => handleUpdate(i, u.email)} className="update">Update</button>
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </main>
    </div>
  );
};

export default CreateAdmin;
